import React from "react";

export default function ContainerShadow(props) {
  return (
    <div className="p-8 bg-white rounded w-full smooth-shadow">
      {props.children}
    </div>
  );
}
